import { Model } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";

export default class User extends jsonapi(Model) {
  static type = "user";
}
